/**
 * The textual representation of the named aspect ratio.
 * This is the value that will be used across the codebase.
 * This value is also saved to the database.
 */
export enum AspectRatio {
  Square = 'SQUARE',
  Portrait = 'PORTRAIT',
  Landscape = 'LANDSCAPE',
  Tall = 'TALL',
  Wide = 'WIDE',
}

/**
 * The fraction of the named aspect ratio.
 * This defines the relations between the name ans the actual ratio.
 * This value is also saved to the database.
 */
export enum AspectRatioFraction {
  Square = '1/1',
  Portrait = '3/4',
  Landscape = '4/3',
  Tall = '9/16',
  Wide = '16/9',
}

/**
 * The decimal value of the named aspect ratio.
 * This is mainly used for aspect ratio related calculations.
 */
export enum AspectRatioDecimal {
  Square = 1,
  Portrait = 0.75,
  Landscape = 1.3333,
  Tall = 0.5625,
  Wide = 1.7778,
}
